module.exports = __webpack_public_path__ + "media/fountain3.8925708e.webm";